import create, { SetState } from "zustand";

type TouchDeviceStoreData = {
	readonly isTouch: boolean;
	readonly setIsTouch: (value: boolean) => void;
};

const mediaQueryList: MediaQueryList = window.matchMedia("(pointer: coarse)");

const getInitialState = (
	set: SetState<TouchDeviceStoreData>
): TouchDeviceStoreData => ({
	isTouch: mediaQueryList.matches,
	setIsTouch: value => {
		set({ isTouch: value });
	}
});

const useTouchDeviceStore = create<TouchDeviceStoreData>(getInitialState);

mediaQueryList.onchange = (event: MediaQueryListEvent) => {
	const { setIsTouch } = useTouchDeviceStore.getState();

	setIsTouch(event.matches);
};

export const useIsTouchDevice = (): boolean => {
	const isTouch: boolean = useTouchDeviceStore(state => state.isTouch);

	return isTouch;
};
